const dateIsValid = date => {
  // Confirm that the date exists, is an instance of a Date object and is valid
  return date && date instanceof Date && !isNaN(date);
};

export default dateIsValid;
